<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold">new employee</small>
      </legend>
      <div>
        <form @submit.prevent="newEmployee()">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Employee names</label>
                <input
                  type="text"
                  class="form-control employee_name"
                  placeholder="employee name"
                  required
                />
              </div>
              <div class="form-group">
                <label>Id number</label>
                <input type="number" class="form-control id_no" placeholder="id no" required />
              </div>
              <div class="form-group">
                <label>Status</label>
                <select name="status" class="form-control status" required>
                  <option value>select status</option>
                  <option value="Active">Active</option>
                  <option value="Reserved">Reserved</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Gender</label>
                <select name="gender" class="form-control gender" required>
                  <option value>select gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
              <div class="form-group">
                <label>Phone number</label>
                <input type="number" class="form-control phone_no" placeholder="phone no" required />
              </div>
              <div class="form-group">
                <label>Truck</label>
                <select class="form-control-lg form-control select2 truck_id" required>
                  <option value>Select truck</option>
                  <option
                    v-for="truck in SystemTruck"
                    :value="truck.id"
                    :key="truck.id"
                  >{{ truck.truck_no }}</option>
                </select>
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingEmployee">
            <i class="fa fa-user"></i> create employee
          </button>
          <button type="button" class="btn btn-info btn-flat creatingEmployeeLoader">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please
            wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
export default {
  created() {
    this.loadTruck();
  },
  computed: {
    ...mapGetters(['SystemTruck'])
  },
  methods: {
    ...mapActions(["newEmployee", "loadTruck"])
  }
};

</script>
<style scoped>
.creatingEmployeeLoader {
  display: none;
}

.form-control {
    display: block;
    width: 100%;
    height: calc(2.25rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/employees/employee.vue